<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']" titleText="i18n.domain.parking-administration.title"></app-title-bar>
@if (hasLinkedParker) {
  <div class="row">
    <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3">
      <div class="row mt-4 align-items-center">
        <div class="col-12">
          <ejs-grid #grid
                    class="grid-with-toolbar"
                    width="100%"
                    rowHeight="38"
                    [dataSource]="data"
                    [allowSorting]="false"
                    [filterSettings]="filterSettings"
                    [allowFiltering]="false"
                    [allowPaging]="false"
                    [pageSettings]="pageSettings"
                    [editSettings]="editSettings"
                    [searchSettings]="searchOptions"
                    (actionComplete)="actionComplete($event)"
                    (actionBegin)="actionBegin($event)">
            <ng-template #toolbarTemplate
                         let-data>
              <ejs-toolbar>
                <e-items>
                  <e-item text="{{ 'i18n.domain.parking-administration.add' |  translate }}"
                          prefixIcon="e-icons icon-add"
                          (click)="onAdd()"></e-item>
                </e-items>
              </ejs-toolbar>
            </ng-template>
            <e-columns>
              <e-column field="id"
                        [visible]="false"
                        headerText="id"
                        [isPrimaryKey]="true"></e-column>
              <e-column field="name"
                        headerText="{{'i18n.domain.parking-administration.grid.name' | translate}}"
                        clipMode="EllipsisWithTooltip">
              </e-column>
              <e-column [headerText]="'i18n.shared.fields.active' | translate"
                        field="isActive"
                        width="160px"
                        [filter]="isActiveFilter">
                <ng-template #filterItemTemplate
                             let-data>{{formatIsActive(data, 'isActive')}}</ng-template>
                <ng-template #template
                             let-data>
                  @if (data.isActive) {
                    <div class="e-icons icon-checkmark align-middle"></div>
                  }
                </ng-template>
              </e-column>
              <e-column headerText=""
                        [commands]="gridCommands"
                        width="100px"></e-column>
            </e-columns>
            <ng-template #editSettingsTemplate
                         let-data>
              <app-parking-administration-edit-form [parkingForm]="gridEditForm"></app-parking-administration-edit-form>
            </ng-template>
          </ejs-grid>
        </div>
      </div>

    </div>
  </div>
} @else {
  <div class="alert alert-danger" role="alert">
    {{'i18n.domain.parking.noLinkedParker' | translate}}
  </div>
}
